import styled from '@emotion/styled';
import { Flex } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledPageContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute !important;
  width: 100%;
  height: 100%;
`;

export const StyledContainer = styled.div`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 760px;
  width: 1298px;
  z-index: 200;

  @media (max-width: 1290px) {
    width: 1180px;
  }
  @media (max-width: 1190px) {
    width: 1009px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    height: 100vh;
    position: fixed !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const StyledFlexLeftSide = styled(Flex)`
  width: 348px;
  height: 760px;

  @media (max-width: 1023px) {
    width: 100%;
    height: 100%;
    display: contents;
  }
`;

export const StyledFlexLoginForm = styled(Flex)`
  width: 950px;
  height: 760px;
  border-radius: 0 10px 10px 0;
  background-color: white;

  @media (max-width: 1290px) {
    width: 832px;
  }

  @media (max-width: 1190px) {
    width: 660px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`;

export const StyledFindOutMoreButton = styled.a`
  width: 160px;
  height: 42px;
  margin: 0px auto !important;
  border: 2px solid ${COLORS.seaBlue}; /* Thicker border */
  border-radius: 8px;
  color: ${COLORS.seaBlue} !important;
  font-size: 16px;
  text-transform: uppercase; /* Ensures capital letters */
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color 0.3s ease-in-out,
    border-color 0.3s;

  &:hover {
    background-color: ${COLORS.lavender};
  }

  &:disabled,
  &[disabled] {
    cursor: not-allowed !important;
    opacity: 0.5 !important;
    border: none !important;
  }

  @media (max-width: 1023px) {
    margin: 0px auto 30px !important;
  }
`;

export default {
  StyledPageContainer,
  StyledContainer,
  StyledFlexLeftSide,
  StyledFlexLoginForm,
};
